

export const getParticipantRoles = () => {
  return [
    { name: 'Custom', value: 'Custom' },
    { name: 'Underwriter/Arranger', value: 'UnderwriterArranger' },
    { name: 'Selling Agent', value: 'SellingAgent' },
    { name: 'Broker Specialist', value: 'BrokerSpecialist' }
  ]
}

export const getUnderWriterArrangers = () => {
  return [
    { name: "AB Capital and Investment Corporation", value: "AB Capital and Investment Corporation" },
    { name: "Amalgamated Investment Bancorporation", value: "Amalgamated Investment Bancorporation" },
    { name: "BDO Capital & Investment Corporation", value: "BDO Capital & Investment Corporation" },
    { name: "BPI Capital Corporation", value: "BPI Capital Corporation" },
    { name: "China Bank Capital Corporation", value: "China Bank Capital Corporation" },
    { name: "Deutsche Bank AG, Manila Branch", value: "Deutsche Bank AG, Manila Branch" },
    { name: "Development Bank of the Philippines", value: "Development Bank of the Philippines" },
    { name: "East West Banking Corporation", value: "East West Banking Corporation" },
    { name: "First Metro Investment Corporation", value: "First Metro Investment Corporation" },
    { name: "ING Bank N.V. Manila Branch", value: "ING Bank N.V. Manila Branch" },
    { name: "Maybank ATR Kim Eng Capital Partners, Inc.", value: "Maybank ATR Kim Eng Capital Partners, Inc." },
    { name: "Multinational Investment Bancorporation", value: "Multinational Investment Bancorporation" },
    { name: "Philippine Commercial Capital, Inc.", value: "Philippine Commercial Capital, Inc." },
    { name: "PNB Capital and Investment Corporation", value: "PNB Capital and Investment Corporation" },
    { name: "RCBC Capital Corporation", value: "RCBC Capital Corporation" },
    { name: "SB Capital Investment Corporation", value: "SB Capital Investment Corporation" },
    { name: "Standard Chartered Bank", value: "Standard Chartered Bank" },
    { name: "The Hongkong and Shanghai Banking Corporation Limited", value: "The Hongkong and Shanghai Banking Corporation Limited" },
    { name: "Unicapital, Inc.", value: "Unicapital, Inc." },
    { name: "Union Bank of the Philippines", value: "Union Bank of the Philippines" },
    { name: "Other", value: "Other" }
  ]
}

export const getSellingAgents = () => {
  return [
    { name: "Asia United Bank Corporation", value: "Asia United Bank Corporation" },
    { name: "Amalgamated Investment Bancorporation", value: "Amalgamated Investment Bancorporation" },
    { name: "Bank of the Philippine Islands", value: "Bank of the Philippine Islands" },
    { name: "BDO Unibank, Inc.", value: "BDO Unibank, Inc." },
    { name: "BDO Capital & Investment Corporation", value: "BDO Capital & Investment Corporation" },
    { name: "BPI Capital Corporation", value: "BPI Capital Corporation" },
    { name: "China Bank Capital Corporation", value: "China Bank Capital Corporation" },
    { name: "Deutsche Bank AG, Manila Branch", value: "Deutsche Bank AG, Manila Branch" },
    { name: "Development Bank of the Philippines", value: "Development Bank of the Philippines" },
    { name: "East West Banking Corporation", value: "East West Banking Corporation" },
    { name: "First Metro Investment Corporation", value: "First Metro Investment Corporation" },
    { name: "ING Bank N.V., Manila Branch", value: "ING Bank N.V., Manila Branch" },
    { name: "Land Bank of the Philippines", value: "Land Bank of the Philippines" },
    { name: "Maybank ATR Kim Eng Capital Partners, Inc.", value: "Maybank ATR Kim Eng Capital Partners, Inc." },
    { name: "Multinational Investment Bancorporation", value: "Multinational Investment Bancorporation" },
    { name: "Philippine Commercial Capital, Inc.", value: "Philippine Commercial Capital, Inc." },
    { name: "PNB Capital and Investment Corporation", value: "PNB Capital and Investment Corporation" },
    { name: "RCBC Capital Corporation", value: "RCBC Capital Corporation" },
    { name: "SB Capital Investment Corporation", value: "SB Capital Investment Corporation" },
    { name: "Standard Chartered Bank", value: "Standard Chartered Bank" },
    { name: "The Hongkong and Shanghai Banking Corporation Limited", value: "The Hongkong and Shanghai Banking Corporation Limited" },
    { name: "Unicapital Inc.", value: "Unicapital Inc." },
    { name: "Union Bank of the Philippines", value: "Union Bank of the Philippines" },
    { name: "United Coconut Planters Bank", value: "United Coconut Planters Bank" }
  ]
}

export const getMarketMakers = () => {
  return [
    { name: "ASIA UNITED BANK CORPORATION", value: "ASIA UNITED BANK CORPORATION" },
    { name: "AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED", value: "AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED" },
    { name: "BANK OF CHINA LIMITED, MANILA BRANCH", value: "BANK OF CHINA LIMITED, MANILA BRANCH" },
    { name: "BANK OF COMMERCE", value: "BANK OF COMMERCE" },
    { name: "BANK OF MAKATI (A SAVINGS BANK), INC.", value: "BANK OF MAKATI (A SAVINGS BANK), INC." },
    { name: "BANK OF THE PHILIPPINE ISLANDS", value: "BANK OF THE PHILIPPINE ISLANDS" },
    { name: "BDO PRIVATE BANK, INC.", value: "BDO PRIVATE BANK, INC." },
    { name: "BDO UNIBANK, INC.", value: "BDO UNIBANK, INC." },
    { name: "BPI CAPITAL CORPORATION", value: "BPI CAPITAL CORPORATION" },
    { name: "CHINA BANKING CORPORATION", value: "CHINA BANKING CORPORATION" },
    { name: "CITIBANK, N.A.", value: "CITIBANK, N.A." },
    { name: "CTBC BANK (PHILIPPINES) CORP.", value: "CTBC BANK (PHILIPPINES) CORP." },
    { name: "DEUTSCHE BANK AG, MANILA BRANCH", value: "DEUTSCHE BANK AG, MANILA BRANCH" },
    { name: "DEVELOPMENT BANK OF THE PHILIPPINES", value: "DEVELOPMENT BANK OF THE PHILIPPINES" },
    { name: "EAST WEST BANKING CORPORATION", value: "EAST WEST BANKING CORPORATION" },
    { name: "FIRST METRO INVESTMENT CORPORATION", value: "FIRST METRO INVESTMENT CORPORATION" },
    { name: "HSBC SAVINGS BANK (PHILIPPINES), INC.", value: "HSBC SAVINGS BANK (PHILIPPINES), INC." },
    { name: "ING BANK N.V., MANILA BRANCH", value: "ING BANK N.V., MANILA BRANCH" },
    { name: "JP MORGAN CHASE BANK N.A., MANILA BRANCH", value: "JP MORGAN CHASE BANK N.A., MANILA BRANCH" },
    { name: "LAND BANK OF THE PHILIPPINES", value: "LAND BANK OF THE PHILIPPINES" },
    { name: "MALAYAN BANK SAVINGS & MORTGAGE BANK", value: "MALAYAN BANK SAVINGS & MORTGAGE BANK" },
    { name: "MAYBANK PHILIPPINES, INC.", value: "MAYBANK PHILIPPINES, INC." },
    { name: "METROPOLITAN BANK & TRUST COMPANY", value: "METROPOLITAN BANK & TRUST COMPANY" },
    { name: "MULTINATIONAL INVESTMENT BANCORPORATION", value: "MULTINATIONAL INVESTMENT BANCORPORATION" },
    { name: "PHILIPPINE BANK OF COMMUNICATIONS", value: "PHILIPPINE BANK OF COMMUNICATIONS" },
    { name: "PHILIPPINE BUSINESS BANK", value: "PHILIPPINE BUSINESS BANK" },
    { name: "PHILIPPINE COMMERCIAL CAPITAL INC.", value: "PHILIPPINE COMMERCIAL CAPITAL INC." },
    { name: "PHILIPPINE NATIONAL BANK", value: "PHILIPPINE NATIONAL BANK" },
    { name: "PHILIPPINE SAVINGS BANK", value: "PHILIPPINE SAVINGS BANK" },
    { name: "PHILIPPINE VETERANS BANK", value: "PHILIPPINE VETERANS BANK" },
    { name: "RIZAL COMMERCIAL BANKING CORPORATION", value: "RIZAL COMMERCIAL BANKING CORPORATION" },
    { name: "ROBINSONS BANK CORPORATION", value: "ROBINSONS BANK CORPORATION" },
    { name: "SECURITY BANK CORPORATION", value: "SECURITY BANK CORPORATION" },
    { name: "STANDARD CHARTERED BANK", value: "STANDARD CHARTERED BANK" },
    { name: "STERLING BANK OF ASIA, INC. (A SAVINGS BANK)", value: "STERLING BANK OF ASIA, INC. (A SAVINGS BANK)" },
    { name: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED", value: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED" },
    { name: "UCPB SAVINGS BANK, INC.", value: "UCPB SAVINGS BANK, INC." },
    { name: "UNICAPITAL, INC.", value: "UNICAPITAL, INC." },
    { name: "UNION BANK OF THE PHILIPPINES", value: "UNION BANK OF THE PHILIPPINES" },
    { name: "UNITED COCONUT PLANTERS BANK", value: "UNITED COCONUT PLANTERS BANK" },
  ]
}




